import { render, staticRenderFns } from "./Template2.vue?vue&type=template&id=0d4e2026&scoped=true&"
import script from "./Template2.vue?vue&type=script&lang=js&"
export * from "./Template2.vue?vue&type=script&lang=js&"
import style0 from "./Template2.vue?vue&type=style&index=0&id=0d4e2026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4e2026",
  null
  
)

export default component.exports